<template>
  <div class="mainContainer" v-loading="loading" id="sbsPage">

    <div class="sbsbigtit">手把手教你做资料</div>
    <div class="sbsbox">
      <div class="sbsdalb">如何建立安全生产资料</div>
      <div class="sbsdaDivbox" id="aqscBox">
        <div class="sbs-every" v-for="(item,i) in listData.rows" v-if="item.itype=='ZXKT_sbsfileItype_1'">
          <div class="sbs-item">
            <div class="sbs-title">
              {{item.title}}
            </div>
            <div class="sbs-conts">{{item.description}}</div>
          </div>
          <div class="sbs-btnxq" @click="toDetail(item.id)">
            查看详情</div>
        </div>
      </div>
    </div>
    <div class="sbsbox" style="margin-top:30px;">
      <div class="sbsdalb">如何建立职业卫生资料</div>
      <div class="sbsdaDivbox" id="zywsBox">
        <div class="sbs-every" v-for="(item,i) in listData.rows" v-if="item.itype=='ZXKT_sbsfileItype_2'">
          <div class="sbs-item">
            <div class="sbs-title">
              {{item.title}}
            </div>
            <div class="sbs-conts">{{item.description}}</div>
          </div>
          <div class="sbs-btnxq" @click="toDetail(item.id)">
            查看详情</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Notice',
    props: ['wjSrc'],
    data() {
      return {
        total: 0,
        list: [],
        params: {
          page: 1,
          rows: 50
        },
        listData: {
          total: 0,
          rows: []
        },
        loading: true
      }
    },
    methods: {
      // 跳转详情
      toDetail: function(id) {
        sessionStorage.setItem('daid', id)
        this.$router.push('/sbsDetail');
      },
      getList: function() {
        this.loading = true;
        // /pub/ktNotify/getlistPage.htm?page=1&rows=10
        this.$axios.get('/kt/ktZjfwInfo/getNollistPage.htm?' + this.$qs.stringify(this.params), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.listData = data;
          this.loading = false;
        })
      },
    },
    created: function() {
      this.getList()
    },
    watch: {
      params: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getList()
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  #sbsPage {
    width: 1400px;
    margin: 30px auto;
  }

  #sbsPage .sbsdaDivbox {
    box-shadow: 0 4px 15px 0 rgb(0 0 0 / 10%);
    margin-top: 1px;
  }

  #sbsPage .sbsbigtit {
    font-size: 28px;
    color: rgb(24, 24, 24);
    line-height: 42px;
    text-align: center;
  }

  #sbsPage .sbsdalb {
    width: 224px;
    height: 45px;
    margin: 0px 0;
    background-image: linear-gradient(to right, #0d6efd, #3d89fc);
    color: #fff;
    border-radius: 0 40px 0px 0;
    font-weight: 600;
    font-size: 18px;
    color: #fff;
    text-align: left;
    padding: 0 44px 0 32px;
    line-height: 48px;
    cursor: auto;
  }

  #sbsPage .sbsdaDivbox {
    display: flex;
    flex-wrap: wrap;
    box-shadow: none;
  }

  #sbsPage .sbsdaDivbox .sbs-every {
    height: 174px;
    border-right: 1px solid #ebecec;
    border-bottom: 1px solid #ebecec;
    transition: .3s;
    position: relative;
    cursor: pointer;
    width: 23%;
    margin: 20px 0 0;
    margin-right: 1.5%;
    background: #fff;
    color: #fff;
    box-shadow: 5px 5px 10px rgba(13, 110, 253, 0.1);
  }



  #sbsPage .sbsdaDivbox .sbs-every .sbs-item {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 32px;
    right: 24px;
    animation-timing-function: ease-in-out;
    animation-duration: .3s;
  }

  #sbsPage .sbsdaDivbox .sbs-every:hover {
    transition: all .3s;
    box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%), inset -1px -1px 0 0 #ebecec;
  }

  #sbsPage .sbsdaDivbox .sbs-every:hover .sbs-item .sbs-title {
    color: #0d6efd;
  }

  #sbsPage .sbsdaDivbox .sbs-every:hover .sbs-item {
    top: calc(50% - 18px);
    transition: all .3s;
  }

  #sbsPage .sbsdaDivbox .sbs-every .sbs-item .sbs-title {
    font-family: PingFangSC-Medium;
    font-size: 15px;
    color: #181818;
    line-height: 24px;
    font-weight: 800;
  }

  #sbsPage .sbsdaDivbox .sbs-every .sbs-item .sbs-title .sbs-itype {
    color: #0d6efd;
    /* border: 1px solid ; */
  }

  #sbsPage .sbsdaDivbox .sbs-every .sbs-item .sbs-conts {
    font-size: 14px;
    color: #999;
    letter-spacing: 0;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    height: 72px;
    -webkit-line-clamp: 3;
    margin-top: 4px;
    -webkit-box-orient: vertical;
  }

  #sbsPage .sbsdaDivbox .sbs-every .sbs-btnxq {
    visibility: hidden;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    opacity: 0;
    background-color: #0d6efd;
    height: 36px;
    color: #fff;
    text-align: center;
    font-size: 14px;
  }

  #sbsPage .sbsdaDivbox .sbs-every:hover .sbs-btnxq {
    opacity: 1;
    visibility: visible;
    transition: all .3s;
    line-height: 36px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sbsda.vue